import { FC, useEffect, useState } from "react";
import {
  Stack,
  Box,
  useColorModeValue,
  Center,
  Text,
  Spinner,
} from "@chakra-ui/react";
import Layout from "components/Layout";
import Logo from "components/Logo";
import useAuth from "hooks/useAuth";
import { useSearchParams } from "react-router-dom";
import { getErrorMessage } from "utils";

const VerifyDeleteAccount: FC = () => {
  const { verifyAccountDeletion } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const [searchParams] = useSearchParams();

  useEffect(() => {
    setLoading(true);
    const key = searchParams.get("key");
    if (key) {
      verifyAccountDeletion({ uid: key })
        .then(() => {
          setLoading(false);
          setResult("Akun dan data anda berhasil dihapus dari sistem kami.");
        })
        .catch((error) => {
          console.log(error);
          setResult(getErrorMessage(error));
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout withSidebar={false}>
      <Center minH="100vh">
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
          w="sm"
        >
          <Center mb="6">
            <Logo mb="6" w="60%" />
          </Center>
          {isLoading ? (
            <Stack alignItems="center">
              <Spinner size="md" />
              <Text>Sedang memproses penghapusan akun...</Text>
            </Stack>
          ) : (
            <Text mb="4" textAlign="center">
              {result}
            </Text>
          )}
        </Box>
      </Center>
    </Layout>
  );
};

export default VerifyDeleteAccount;
